const isRtl = !!document.querySelector('[dir="rtl"]');

export default isRtl;
